import { Component, Input, Output, NgZone, ElementRef } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/map'
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { httpService } from '../service/servicio'
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ViewContainerRef } from '@angular/core';
import { Carga } from '../datos/carga'
import * as jsPDF from 'jspdf'

@Component({
  selector: 'app-facturas',
  templateUrl: './facturas.component.html',
  styleUrls: ['./facturas.component.css']
})

export class FacturasComponent {

  constructor(private http: httpService, public toastr: ToastsManager, vcr: ViewContainerRef, private elem: ElementRef) {

    this.toastr.setRootViewContainerRef(vcr);
    ("en cargas-..");
    this.loaded = false;
    this.descargarFacturas();
    this.descargarClientes();

  };


  uploaded = {
    Status: 0,
    Text: ''

  }

  public fInicio: string = this.hoy();
  public fFinal: string = this.hoy();

  @Input() facturas: any = [];
  @Input() clientes: any = [];
  @Input() DetalleFactura: any = [];
  @Output() facturaGrabar: any = {
    Id: 0,
    cliente: 0,
    fecha: ''
  }
  @Output() detalleFacturaGrabar: any = {
    Id: 0,
    IdFactura: 0,
    Tipo: 0,
    Concepto: '',
    Visible: 0,
    Importe: 0.00,
    Unidades: 0.00,
    Iva: 0,
    Tiva: 0.00,
    timporte: 0.00,
    Total: 0.00
  }

  tituloFacturas: string = '';
  titulomostrarLineas: string = '';
  facturasSearch: string = '';
  clienteSearch: string = '';
  place: string = 'Buscar por Cliente';
  sort: string = 'Nombre';
  mostrarDatosFacturas: boolean = false;
  mostrarLineasFacturas: boolean = false;
  mostrarLineas: boolean = false;
  mostrarFacturas: boolean = true;
  loaded: boolean = false;
  sum: number = 0.0;
  stringFiltro: string = 'Cliente'

  Fecha: string = this.hoy();
  IdCliente: any;
  IdFactura: 0;
  IdDetalleFactura: 0;
  FechaFactura: any;

  // Datos detalle Facturas

  Concepto: string = ''
  Unidades: string = ''
  Iva: string = ''
  Precio: string = ''
  mostrarDetalle: string = 'Añadir Linea'
  iUnidades: any;
  iPrecio: any;
  comentario: any;


  imagen(doc, num) {

    console.log('imprimir')

    var url = '/assets/img/logoDuran.jpg'
    var img = new Image();
    var dataURL;

    img.src = url;

    let numFact = this.IdFactura;

    img.onload = function() {
      var canvas = document.createElement('canvas');
      canvas.width = doc.width;
      canvas.height = doc.height;

      var context = canvas.getContext('2d');
      context.drawImage(img, 0, 0);

      dataURL = canvas.toDataURL('image/jpeg');

      doc.addImage(img, "JPEG", 350, 20, 200, 100);

      //var pdfString = doc.output('datauristring'); //base64 string from jsPDF

      doc.save('Factura' + num + '.pdf');


}



  };

  cuadro(doc, x1, y1, x2, y2){
    doc.line(x1,y1,x2,y1);
    doc.line(x2,y1,x2,y2);
    doc.line(x2,y2,x1,y2);
    doc.line(x1,y2,x1,y1);

  }

  alinear(doc, x, y, text, hAlign) {
    var splitRegex = /\r\n|\r|\n/g;

    var fontSize = 10;
    var vAlign = hAlign;

    // As defined in jsPDF source code
    var lineHeightProportion = 1.15;

    var splittedText = null;
    var lineCount = 1;
    if (vAlign === 'middle' || vAlign === 'bottom' || hAlign === 'center' || hAlign === 'right') {
      splittedText = typeof text === 'string' ? text.split(splitRegex) : text;

      lineCount = splittedText.length || 1;
    }

    // Align the top
    y += fontSize * (2 - lineHeightProportion);

    if (vAlign === 'middle')
      y -= (lineCount / 2) * fontSize;
    else if (vAlign === 'bottom')
      y -= lineCount * fontSize;

    if (hAlign === 'center' || hAlign === 'right') {
      var alignSize = fontSize;
      if (hAlign === 'center')
        alignSize *= 0.5;

      if (lineCount > 1) {
        for (var iLine = 0; iLine < splittedText.length; iLine++) {
          doc.text(splittedText[iLine], x - doc.getStringUnitWidth(splittedText[iLine]) * alignSize, y);
          y += fontSize;
        }

      }
      x -= doc.getStringUnitWidth(text) * alignSize;
    }

    doc.text(text, x, y);

  };

  imprimirFactura() {

    let fact = this.facturas.find(factura => factura.Id == this.DetalleFactura[0].IdFactura);

    let sw:boolean = false;

    let cliente = this.clientes.find(cliente => cliente.Id == fact.IdCliente);

    console.log(fact, ",", cliente);

    let doc = new jsPDF('p', 'pt');
    doc.setFont("courier");
    doc.setFontSize(10);
    doc.setFontType("bold");


    doc.text(50, 40, "FERNANDO JESUS DURAN ROCA");
    doc.text(50, 55, "C.I.F.: 53.710.441-J")
    doc.text(50, 70, "C/ Muñiz el Poeta, 124");
    doc.text(50, 85, "11206 Algeciras, Cádiz");
    this.cuadro(doc, 20,10,560,122);


    let y = 135;
    this.alinear(doc, 30, y + 10, "DATOS CLIENTE", "left");
    //doc.line(10, 100, 550, 100);
    doc.setFontType("normal");

    this.alinear(doc, 30, y + 30, cliente.Nombre, "left")
    this.alinear(doc, 30, y + 45, cliente.documento, "left")
    this.alinear(doc, 30, y + 60, cliente.direccion, "left")
    this.cuadro(doc, 20,y+8,560,y+80);

    y = y + 100;

    doc.setFontType("bold");

    this.alinear(doc, 30, y, "Factura nº: " + fact.Id, "left");
    this.alinear(doc, 550, y, "Fecha: " + this.http.fecha(fact.fecha), "right")
    this.cuadro(doc, 20,y-8,560,y+20);

    y = y + 30;


    this.alinear(doc, 30, y, "Concepto", "left")
    this.alinear(doc, 300, y, "Unid.", "right")
    this.alinear(doc, 360, y, "Precio", "right")
    this.alinear(doc, 400, y, "%Iva", "right")
    this.alinear(doc, 450, y, "Neto", "right")
    this.alinear(doc, 500, y, "IVA", "right")
    this.alinear(doc, 560, y, "Total", "right")
    doc.line(30, y+12, 560, y+12)

    y = y + 20;

    doc.setFontType("normal");



    this.DetalleFactura.forEach(detalle => {

      if (sw) {
       doc.setTextColor(128,128,128)
      }else {
       doc.setTextColor(0,0,0)
      }

      if (detalle.Visible == 0)
        this.alinear(doc, 30, y, detalle.Concepto.slice(0, 35), "left")
      else
        this.alinear(doc, 30, y, detalle.Concepto.slice(0, 80), "left")

      if (detalle.Visible == 0) {
        this.alinear(doc, 300, y, detalle.Unidades, "right")
        this.alinear(doc, 360, y, parseFloat(detalle.Importe).toFixed(2), "right")
        this.alinear(doc, 400, y, parseFloat(detalle.Iva).toFixed(2), "right")
        this.alinear(doc, 450, y, parseFloat(detalle.timporte).toFixed(2), "right")
        this.alinear(doc, 500, y, parseFloat(detalle.Tiva).toFixed(2), "right")
        this.alinear(doc, 560, y, parseFloat(detalle.Total).toFixed(2), "right")

      }
      y += 15;

    })

    sw = !sw;

    doc.setFontType("bold");
    doc.setFontSize(12);

    y = 720;
    // 
    doc.setFontType("bold");
    doc.setFontSize(5);
    doc.line(30,y + 85, 560, y + 85);
    this.alinear(doc, 30, y + 85,  this.lopd, "left")
    this.alinear(doc, 30, y + 90,  this.lopd1, "left")
    this.alinear(doc, 30, y + 95, this.lopd2, "left")
    this.alinear(doc, 30, y + 100, this.lopd3, "left")
    this.alinear(doc, 30, y + 105, this.lopd4, "left")
    doc.setFontSize(12);

    //
    this.alinear(doc, 400, y + 20, "Neto:", "left")
    this.alinear(doc, 400, y + 40, "IVA:", "left")
    this.alinear(doc, 400, y + 60, "Total:", "left")
    doc.setFontType("normal");
    this.alinear(doc, 550, y + 20, parseFloat(this.sumaImporte()).toFixed(2) + "€", "right")
    this.alinear(doc, 550, y + 40, parseFloat(this.sumaIva()).toFixed(2) + "€", "right")
    doc.setFontType("bold");
    this.alinear(doc, 550, y + 60, parseFloat(fact.TotalFactura).toFixed(2) + "€", "right")
    this.cuadro(doc, 395,y+55,560,y+75);
    doc.line(30,y, 560, y);
    this.alinear(doc, 30, y - 10, "Desglose Total Factura", "left")

    //doc.line(30,y -20, 570, y-20);
   
    //doc.save('Factura1.pdf');


    this.imagen(doc, fact.Id)


  }

  lopd: string  = 'Le informamos que en VENDING, STC tratamos la información que nos facilita con el fin de gestionar nuestra relación negocial, poder informarle de nuestros servicios y realizar';
  lopd1: string = 'y facturar los servicios. Los datos proporcionados se conservarán mientras se mantenga la relación  comercial o  durante los años necesarios para  cumplir con las obligaciones';
  lopd2: string = 'legales. Los datos no se cederán a terceros salvo en los casos en que  exista exista una obligación legal. Usted tiene derecho a obtener confirmación sobre si estamos tratando';
  lopd3: string = 'sus datos personales por tanto tiene derecho a acceder a sus datos personales, rectificar los datos inexactos o solicitar su supresión cuando los datos ya  no  sean necesarios';
  lopd4: string = 'dirigiéndose por escrito CALLE BENAOCAZ, 21, 11206, ALGECIRAS, CÁDIZ o al correo electrónico f.duran-algeciras@hotmail.com'

  listar() {


    // Only pt supported (not mm or in)


    let doc = new jsPDF('p', 'pt');

    doc.setFont("courier");
    doc.setFontSize(12);
    doc.setFontType("bold");

    doc.text(15,20,"Listado de Facturas ( " + this.filtro().length + " )")
    doc.setFontSize(10);
    if (this.facturasSearch != '') doc.text(15,40,"Filtro: " +  this.stringFiltro + ' = ' + this.facturasSearch);
    doc.text(15,60,"Facturas del " + this.http.fecha(this.fInicio) + " al " + this.http.fecha(this.fFinal));
    doc.text(500, 20, this.http.hoy())
    doc.line(15,25,585,25);

    let lineas:any = [];
    let y: number = 80;


    doc.setFontType("normal");


      doc.setFontSize(10);
      doc.setFontType("bold");

      this.alinear(doc, 15, y, "Id", "left")
      this.alinear(doc, 45, y, "Fecha.", "left")
      this.alinear(doc, 120, y, "Cliente.", "left")
      this.alinear(doc, 450, y, "Importe", "right")
      this.alinear(doc, 500, y, "IVA", "right")
      this.alinear(doc, 560, y, "Total", "right")

      doc.line(15, y + 10, 585, y + 10)

     y = 100;
     doc.setFontType("normal");
     let sw:boolean =true;

     let tabla:any = this.filtro();

     tabla.forEach(factura => {
            if (sw) {
             doc.setTextColor(128,128,128)
            }else {
             doc.setTextColor(0,0,0)
            }

            this.alinear(doc, 15, y, factura.Id, "left")
            this.alinear(doc, 45, y, this.http.fecha(factura.fecha), "left")
            this.alinear(doc, 120, y, factura.Nombre.slice(0,45), "left")
            this.alinear(doc, 450, y, parseFloat(factura.TotalImporte).toFixed(2), "right")
            this.alinear(doc, 500, y, parseFloat(factura.TotalIva).toFixed(2), "right")
            this.alinear(doc, 560, y, parseFloat(factura.TotalFactura).toFixed(2), "right")


           sw = !sw;

           y+=20;
           if (y > 800)  { doc.addPage(); y = 35 }

      })

      y+=30;
      doc.setFontType("bold");

      let importe = this.sumaImporteFacturas();
      let iva =  this.sumaIvaFacturas();
      let total = this.sumaTotalFacturas();

      importe = parseFloat(importe).toFixed(2);
      iva = parseFloat(iva).toFixed(2);
      total = parseFloat(total).toFixed(2);

      this.alinear(doc, 450, y, importe, "right")
      this.alinear(doc, 500, y, iva, "right")
      this.alinear(doc, 560, y, total, "right")

      doc.save('ListadoFacturas.pdf');


  }


  sumaImporte() {
    return (this.DetalleFactura.reduce((sum, item) => sum + (+item.timporte), 0))
  }


  sumaIva() {
    return (this.DetalleFactura.reduce((sum, item) => sum + (+item.Tiva), 0))
  }

  sumaTotal() {
    return (this.DetalleFactura.reduce((sum, item) => sum + (+item.Total), 0))
  }

  sumaImporteFacturas() {
    return (this.facturas.reduce((sum, item) => sum + (+item.TotalImporte), 0))
  }


  sumaIvaFacturas() {
    return (this.facturas.reduce((sum, item) => sum + (+item.TotalIva), 0))
  }

  sumaTotalFacturas() {
    return (this.facturas.reduce((sum, item) => sum + (+item.TotalFactura), 0))
  }

  orden(n) {
    if (n == 1) { this.sort = 'Id'; this.place = 'Buscar por Id'; this.stringFiltro = "Id" };
    if (n == 2) { this.sort = 'Nombre'; this.place = 'Buscar por Cliente'; this.stringFiltro = "Cliente" };

  }

  quitarfiltro(tipo: Number) {
    this.facturasSearch = '';
  }

  hoy() {

    let today = new Date();
    let dd = today.getDate().toString();
    let mm = (today.getMonth() + 1).toString();
    let yyyy: string;


    if (today.getDate() < 10) {

      dd = '0' + dd;
    }

    if (today.getMonth() < 10) {
      mm = '0' + mm;
    }

    yyyy = today.getFullYear().toString();

    let fecha = yyyy + '-' + mm + '-' + dd;

    return fecha;

  }

  suma() {
    return (this.filtro().reduce((sum, item) => sum + (+item.Importe), 0))
  }

  devolucion() {
    return (this.filtro().reduce((sum, item) => sum + (+item.Devolucion), 0))
  }


  filtro() {

    return this.facturas.filter((factura) => {
      if (this.sort == 'Id') {
        return factura.Id.toLowerCase().indexOf(this.facturasSearch.toLowerCase()) != -1;
      }
      if (this.sort == 'Nombre') {
        return factura.Nombre.toLowerCase().indexOf(this.facturasSearch.toLowerCase()) != -1;
      }

    });
  }

  filtrocliente() {

    return this.clientes.filter((cliente) => {
      return cliente.Nombre.toLowerCase().indexOf(this.clienteSearch.toLowerCase()) != -1;
    });

  }


  descargarFacturas() {

    this.http.descargarFacturas(this.fInicio, this.fFinal)
      .subscribe(recaudacion => {
        this.facturas = recaudacion;

      }, err => {

      }, () => {
        if (this.facturas == null) {

          this.toastr.warning("No existen Facturas", "Facturas");

        }
        //this.orden(2);
        this.loaded = true;
        console.log(this.facturas)


      });
  }

  descargarClientes() {
    this.http.descargarClientes()
      .subscribe(cliente => {
        this.clientes = cliente;

      }, err => {

      }, () => {

      });
  }

  pulsado(factura) {
    console.log(factura)
    this.IdFactura = factura.Id;
    this.Fecha = factura.fecha;
    this.http.descargarClientes()
      .subscribe(cliente => {
        this.clientes = cliente;

      }, err => {

      }, () => {
        console.log(this.clientes)

        this.IdCliente = this.clientes.find(cli => cli.Id === factura.IdCliente)
        console.log("Cliente: ", this.IdCliente)
        this.tituloFacturas = 'Editando Factura'
        this.mostrarDatosFacturas = true;
        this.facturasSearch = '';
        this.mostrarFacturas = false;

      });

  }

  crearFactura() {

    this.tituloFacturas = "Crear Nueva Factura"
    this.Fecha = this.http.hoyy();
    this.IdFactura = 0;
    this.http.descargarClientes()
      .subscribe(cliente => {
        this.clientes = cliente;
        console.log(this.clientes)

      }, err => {
        (err.message);
      }, () => {

        this.facturaGrabar.cliente = this.clientes[0].Id;
        this.IdCliente = this.clientes[0].Id;
        this.facturaGrabar.fecha = this.http.hoy();
        this.mostrarDatosFacturas = true;
        this.mostrarFacturas = false;
        console.log("Factura: ", this.facturaGrabar)
      });
  }

  selCliente(Id) {

    this.facturaGrabar.cliente = Id;
    console.log(Id)
  }

  volver() {
    this.http.sw.mostrarDatosmaquinas = true;
    this.toastr.warning("Cargando Datos...", "Internet");
  }

  cancelar() {

    this.mostrarDatosFacturas = false;

  }

  borrarpulsado(factura) {
    ("Borrar pulsado");
    this.facturaGrabar.Id = factura.Id;
  }

  borrar() {

    this.http.datosPost.action = 2; // borrar
    this.http.datosPost.datos = this.facturaGrabar;
    console.log("Borrar Factura: ", this.facturaGrabar)
    this.http.facturas(this.http.datosPost).subscribe(respuesta => {
      this.http.uploaded = respuesta;

    }, err => {
      (err.message);
    }, () => {
      if (this.http.uploaded.Status == 1) {
        this.toastr.success(this.http.uploaded.Text, 'Facturas');
        this.descargarFacturas();

      } else {

        this.toastr.error(this.http.uploaded.Text, 'Facturas');
      }
    });
  }

  grabar() {
    let id = (<HTMLInputElement>document.getElementById('combo')).value;
    let cliente = this.clientes.find(cliente => cliente.Id === id)

    if (this.IdFactura == 0)
      this.http.datosPost.action = 0
    else
      this.http.datosPost.action = 1

    this.facturaGrabar.cliente = id;
    this.facturaGrabar.fecha = this.Fecha;
    this.facturaGrabar.Id = this.IdFactura;

    this.http.datosPost.datos = this.facturaGrabar;

    this.http.facturas(this.http.datosPost).subscribe(respuesta => {
      this.http.uploaded = respuesta;
      console.log(respuesta)

    }, err => {

    }, () => {
      if (this.http.uploaded.Status == 1) {
        this.toastr.success(this.http.uploaded.Text, 'Factura');
        this.http.descargarFacturas(this.fInicio, this.fFinal).subscribe(respuesta => {
          this.facturas = respuesta;
          this.mostrarDatosFacturas = false;
          this.mostrarFacturas = true;

        });
      } else {
        this.toastr.error(this.http.uploaded.Text, 'Factura');
      }
    });

  }

  cancelarDatosFacturas() {
    this.mostrarDatosFacturas = false;
    this.mostrarFacturas = true;

  }

  verfactura(factura) {
    this.IdFactura = factura.Id;
    this.Concepto = '';
    this.Unidades = '';
    this.Precio = '';
    this.Iva = '';
    this.IdDetalleFactura = 0;
    this.titulomostrarLineas = "Editando Factura Nº: " + factura.Factura + ' ' + factura.Nombre + ' de fecha: ' + factura.fecha;
    this.http.descargarDetalleFacturas(factura.Id).subscribe(detalle => {
      this.DetalleFactura = detalle
      console.log(this.DetalleFactura)
      this.mostrarFacturas = false;
      this.mostrarDatosFacturas = false;
      this.mostrarLineasFacturas = true;
      this.IdDetalleFactura = 0;
    }, err => {
      this.toastr.error(this.http.uploaded.Text, 'Factura');
    });

  }

  cancelarDetalle() {
    this.descargarFacturas();
    this.mostrarFacturas = true;
    this.mostrarLineasFacturas = false;


  }

  pulsadodetalle(detalle) {

    this.IdDetalleFactura = detalle.Id;
    this.Concepto = detalle.Concepto;
    this.Unidades = detalle.Unidades;
    this.Precio = detalle.Importe;
    this.Iva = detalle.Iva;
    this.comentario = (detalle.Visible == 1) ? true : false;
    this.mostrarDetalle = 'Actualizar Linea'

  }

  nuevoDetalle(Id) {

    this.mostrarDetalle = 'Nueva Linea'
    this.pasardatos();

    if (this.IdDetalleFactura == 0)
      this.http.datosPost.action = 0
    else
      this.http.datosPost.action = 1;

    if (Id != 0) {
      this.http.datosPost.action = 2;
      this.detalleFacturaGrabar.Id = Id;
    }


    this.http.datosPost.datos = this.detalleFacturaGrabar;

    console.log("Datos POST Detalle: ", this.http.datosPost)

    this.http.detallefactura(this.http.datosPost).subscribe(respuesta => {
      this.http.uploaded = respuesta;
      console.log(respuesta)
      if (this.http.uploaded.Status == 1) {
        this.toastr.success(this.http.uploaded.Text, 'Linea Factura');
        this.Concepto = '';
        this.Unidades = '';
        this.Precio = '';
        this.Iva = '';
        this.comentario = false;
        this.IdDetalleFactura = 0;
        this.mostrarDetalle = 'Añadir Linea';
        this.http.descargarDetalleFacturas(this.IdFactura).subscribe(respuesta => {
        this.DetalleFactura = respuesta;

        });
      } else {
        this.toastr.error(this.http.uploaded.Text, 'Linea Factura');
      }

    }, err => {
      this.toastr.error('Error: ' + err.toString(), 'Linea Factura');

    });




  }



  pasardatos() {

    let iImporte = 0;
    let iIva = 0;
    let iTotal = 0;
    console.log("Pasar datos...")

    this.iUnidades = +this.Unidades;
    this.iPrecio = +this.Precio;
    iImporte = this.iUnidades * this.iPrecio;
    iIva = +this.Iva * iImporte / 100;
    iTotal = iImporte + iIva;


    this.detalleFacturaGrabar.Id = this.IdDetalleFactura;
    this.detalleFacturaGrabar.IdFactura = this.IdFactura;
    this.detalleFacturaGrabar.Tipo = 0;
    this.detalleFacturaGrabar.Concepto = this.Concepto;
    this.detalleFacturaGrabar.Visible = this.comentario ? 1 : 0;
    this.detalleFacturaGrabar.Importe = this.iPrecio;
    this.detalleFacturaGrabar.Unidades = this.iUnidades;
    this.detalleFacturaGrabar.Iva = +this.Iva;
    this.detalleFacturaGrabar.Tiva = iIva;
    this.detalleFacturaGrabar.timporte = iImporte;
    this.detalleFacturaGrabar.Total = iTotal;

    console.log("Detalle: ", this.detalleFacturaGrabar)
  }


}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/duran/duran-web/src/app/facturas/facturas.component.ts